import app from '#app/app'
import { appLayout } from '#app/init_app_layout'
import { addRoutes } from '#app/lib/router'
import { commands, reqres } from '#app/radio'
import ReservationsPage from './components/reservations_page.svelte'

export default {
  initialize () {
    addRoutes({
      '/reservations(/)': 'showReservations',
      '/reservations/admin/current-borrowed(/)': 'showAdminCurrentBorrowed',
      '/reservations/admin/acquisitions(/)': 'showAcquisitions',
    }, {
      async showAcquisitions () {
        if (reqres.request('require:admin:access', 'reservations/admin/acquisitions')) {
          commands.execute('show:loader')
          const { default: AcquisitionsPage } = await import('./components/acquisitions_page.svelte')
          appLayout.showChildComponent('main', AcquisitionsPage)
          app.navigate('reservations/admin/acquisitions', { metadata: { title: 'Livres en recherche / à venir' } })
        }
      },
      showReservations () {
        appLayout.showChildComponent('main', ReservationsPage)
      },
      async showAdminCurrentBorrowed () {
        if (reqres.request('require:admin:access', 'reservations/admin/current-borrowed')) {
          commands.execute('show:loader')
          const { default: CurrentBorrowedBooks } = await import('./components/current_borrowed_books.svelte')
          appLayout.showChildComponent('main', CurrentBorrowedBooks)
          app.navigate('reservations/admin/current-borrowed', { metadata: { title: 'Gestion des emprunts' } })
        }
      },
    })
  },
}
